module.exports = __webpack_public_path__ + "img/25_22.49ef7a49.png";